// extracted by mini-css-extract-plugin
module.exports = {"introduccio":"Introduccio_introduccio__3P1Yx","ultimaData":"Introduccio_ultimaData__3j6fl","btnPujaFoto":"Introduccio_btnPujaFoto__i3bvZ"};